import { defineStore } from "pinia";

export interface AssetInterface {
  id: string;
  slug: string;
  urlplay: string;
  year: string;
  length: string;
  duration: string;
  downloadable: boolean;
  seconds: string;
  fav: boolean;
  like: null;
  type: string;
  trailer: string;
  country: string;
  title: string;
  title_logo: null;
  synopsis: string;
  message: null;
  short_synopsis: string;
  poster: null;
  subs_es: null;
  subs_en: null;
  tv_rating: string;
  screenshot: null;
  orizon_desktop: null;
  orizon_mobile: null;
  website: null;
  actors: string[];
  director: string[];
  genres: string[];
  current: {
    episode_id: string;
    episode: string;
    serie_id: string;
    title: null;
    description: null;
    img: null;
    urlplay: string;
    sub_es: string;
    sub_en: string;
    season: string;
    next: string;
    next_show_button: string;
    next_jump_to: string;
    next_count_down: string;
    skipintro_show_button: string;
    skipintro_hide_button: string;
    skipintro_jump_to: string;
    duration: string;
    seconds: string;
    preview: string;
    subs_en: string;
    subs_es: string;
  };
  downlodeable: boolean;
  rating: null;
  seasons: any[];
  preview: string;
  trailers_extras: {
    title: string;
    url: string;
    type: string;
    thumbnail: null;
  }[];
}

export const AssetStore = defineStore({
  id: "assetStore",
  state: () => ({
    assets: {
      default: {},
    },
    continueWatching: false,
    ids: [],
    language: "es",
  }),
  actions: {
    updatePosition(id: string, seconds: number) {
      // @ts-ignore
      this.assets[id].seconds = seconds.toString();
    },
    setAssets(a: object, lang: string) {
      this.language = lang;
      this.assets = Object.assign({}, this.assets, a);
      // @ts-ignore
      this.ids = Object.keys(this.assets);
    },
    setAsset(id: string, asset: AssetInterface) {
      console.log("updating asset");
      // @ts-ignore
      this.assets[id] = asset;
      // @ts-ignore
      this.ids.push(id);
    },
    setCurrentEpisodeForAsset(id: any, season: any, episode: any) {
      // @ts-ignore
      const seasonIndex = this.assets[id].seasons?.find(
        (s: any) => s.season === season
      );
      // @ts-ignore
      this.assets[id].current = seasonIndex?.episodes?.find(
        (e: any) => e.episode === episode
      );
      // @ts-ignore
      return this.assets[id].current;
    },

    getCurrentEpisodeForAsset(id: any, season: any, episode: any) {
      // @ts-ignore
      const asset = this.assets[id];
      // @ts-ignore
      const seasonIndex = asset.seasons?.findIndex(
        (s: any) => s.season === season
      );
      // @ts-ignore
      const episodeIndex = asset.seasons[seasonIndex].episodes?.findIndex(
        (e: any) => e.episode === episode
      );

      return asset.seasons[seasonIndex].episodes[episodeIndex];
    },

    getNextEpisodeForAsset(id: any, season: any, episode: any) {
      // @ts-ignore
      const asset = this.assets[id];
      // @ts-ignore
      const seasonIndex = asset.seasons?.findIndex(
        (s: any) => s.season === season
      );
      // @ts-ignore
      const episodeIndex = asset.seasons[seasonIndex].episodes?.findIndex(
        (e: any) => e.episode === episode
      );
      const isLastElement =
        episodeIndex === asset.seasons[seasonIndex].episodes.length - 1;
      const firstEpisode = asset.seasons[seasonIndex].episodes[0];
      const nextEpisode = asset.seasons[seasonIndex].episodes[episodeIndex + 1];
      return isLastElement ? firstEpisode : nextEpisode;
    },

    updateCurrentEpisodeTime(id: any, time: any) {
      // @ts-ignore
      const asset = this.assets[id];
      // @ts-ignore
      const seasonIndex = asset.seasons?.findIndex(
        (s: any) => s.season === asset.current.season
      );
      // @ts-ignore
      const episodeIndex = asset.seasons[seasonIndex].episodes?.findIndex(
        (e: any) => e.episode === asset.current.episode
      );
      // @ts-ignore
      this.assets[id].seasons[seasonIndex].episodes[episodeIndex].seconds =
        time;

      // @ts-ignore
      this.assets[id].current.seconds = time;
      // @ts-ignore
      this.assets[id].seconds = time;
    },
    getAssetData(id: string): AssetInterface {
      // @ts-ignore
      return this.assets[id];
    },
    getAssetBySlug(slug: string): AssetInterface {
      // @ts-ignore
      return Object.values(this.assets).find((asset) => asset.slug === slug);
    },
    getIds(): string[] {
      // @ts-ignore
      return this.ids;
    },
    setContinueWatching(value: boolean): boolean {
      this.continueWatching = value;
      return this.continueWatching;
    },
  },
  getters: {
    getLanguage(): string | null {
      return this.language;
    },
    getAssets(): object {
      return this.assets;
    },
    getContinueWatching(): boolean {
      return this.continueWatching;
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "flxAssets",
        storage: localStorage,
      },
    ],
  },
});
